module.exports = __webpack_public_path__ + "static/media/Nova_02.d812cc6c.png";